/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORTS : PAYMENT: STYLES --------------- ++++++++++ */
export default theme =>({
  payment: {
    '& .sectioncard': {
      padding: 0,
      overflow: 'visible',
      '& > div': {
        opacity: '0',
        animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
        animationDelay: '.15s',
        display: 'flex',
        flexDirection:'column'
      }
    },
    '& .name-paymentterm': {
      display: 'flex',
      flexDirection: 'column',
      padding: pxToEm(32),
      paddingBottom: pxToEm(0),
      alignSelf: 'flex-start',
      '& .title': {
        padding: pxToEm(0),
        paddingTop: pxToEm(0),
        margin: pxToEm(0),
        '& p':{
          fontSize: pxToEm(14),
          paddingBottom: pxToEm(16),
        }
      },
      '& .singleselectdropdown': {
        zIndex: 9,
      },
      '& .button': {
        marginTop: pxToEm(16),
      }
    },
    '& .emptystate': {
      padding: replacePXinStringWithEM('40px 40px 60px'),
    },
    '& .button': {
      height: pxToEm(32),
      maxWidth: pxToEm(180),
      padding: replacePXinStringWithEM('0 16px'),
      '& .text': {
        fontSize: pxToEm(14)
      }
    }
  }
});
